<!-- 报警管理-报警设置  -->
<template>
  <div class="data-monitoring-container">
    <!-- 顶部标题栏 -->
    <div class="header-section">
      <div class="title-wrapper">
        <h2 class="page-title">桂枝岭水厂报警设置</h2>
      </div>
      <div class="action-wrapper">
        <a-select v-model="selectedPlant" style="width: 200px; margin-right: 16px;">
          <a-select-option value="guizhiling">桂枝岭水厂</a-select-option>
        </a-select>
        <a-button type="primary">
          <a-icon type="swap" /> 切换水厂
        </a-button>
      </div>
    </div>

    <a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
          <a-row :gutter="48">
            <!-- 第一排 -->
            <a-col :md="6" :sm="12">
              <a-form-item label="所属区域">
                <a-select v-model="query.regionId" placeholder="请选择所属区域" allow-clear>
                  <a-select-option v-for="item in regionList" :key="item.value" :value="item.value">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="设备类型">
                <a-select v-model="query.equipmentType" placeholder="请选择设备类型" allow-clear>
                  <a-select-option v-for="item in equipmentTypeList" :key="item.value" :value="item.value">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.deviceName" placeholder="请输入设备名称" allow-clear />
              </a-form-item>
            </a-col>
            <!-- 第二排-->
            <a-col :md="6" :sm="12">
              <a-form-item label="设备编码">
                <a-input v-model="query.deviceCode" placeholder="请输入设备编码" allow-clear />
              </a-form-item>
            </a-col>
            <!-- 第三排-操作按钮 -->
            <a-col :md="24" :sm="24" :xs="24">
              <div style="margin-bottom: 20px;">
                <a-button type="primary" @click="queryList">查询</a-button>
                <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
                <a-button style="margin-left: 12px" @click="addOrUpdateHandle()" type="primary">新增</a-button>
                <a-button style="margin-left: 12px" @click="deleteSelectRow()" type="danger">删除</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-table rowKey="id" :bordered="true" :data-source="list" :columns="columns" :loading="dataListLoading"
        :pagination="pagination" @change="pageChange" :row-selection="rowSelection">
        <!-- 展开行：一行卡片列表 -->
        <div slot="expandedRowRender" slot-scope="record" class="alarm-card-list">
          <div v-for="item in record.innerData" :key="item.id" class="alarm-card-item">
            <span class="card-field">
              <span class="field-label">报警属性:</span>
              <span class="field-value">{{ item.alarmPropertyName }}</span>
            </span>
            <span class="card-field">
              <span class="field-label">报警名称:</span>
              <span class="field-value field-value--danger">{{ item.alarmName }}</span>
            </span>
            <span class="card-field">
              <span class="field-label">报警阈值:</span>
              <span class="field-value field-value--danger">{{ item.alarmThreshold }}</span>
            </span>
            <span class="card-field">
              <span class="field-label">添加时间:</span>
              <span class="field-value">{{ item.createTime }}</span>
            </span>
            <span class="card-field">
              <span class="field-label">最新修改:</span>
              <span class="field-value">{{ item.updateTime }}</span>
            </span>
          </div>
        </div>

        <!-- 操作列插槽 -->
        <template slot="operation" slot-scope="text, record">
          <a @click="addOrUpdateHandle(record.id)">编辑设备</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common' //选项式混合导入
import storage from 'store'

const columns = [ // 主表列定义
  { title: '工艺单元/车间', dataIndex: 'processUnit', key: 'processUnit' },
  { title: '设备类型', dataIndex: 'deviceType', key: 'deviceType' },
  { title: '设备名称', dataIndex: 'deviceName', key: 'deviceName' },
  { title: '设备编码', dataIndex: 'deviceCode', key: 'deviceCode' },
  { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } },
]

export default {
  mixins: [mixinViewModule],
  name: 'AlarmSetting',
  data () {
    return {
      // 通用属性
      needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      queryUrl: '', //查询url
      querySetting: '', //查询设置
      addOrUpdateUrl: '', //新增or编辑url
      deleteUrl: '', //删除url
      batchDisposeUrl: '', //批量处理url
      exportDataUrl: '', //导出url
      exportFileName: '报警设置导出', //导出名称
      query: {}, //查询对象
      columns,

      // 页面内属性
      selectedPlant: 'guizhiling', //所属水厂
      processUnitList: [ //工艺单元列表
        { value: '1', name: '加药间' },
        { value: '2', name: '沉淀池' },
        { value: '3', name: '滤池' },
        { value: '4', name: '送水泵房' },
      ],
      equipmentTypeList: [ //设备类型列表
        { value: '1', name: '加药泵' },
        { value: '2', name: '流量计' },
        { value: '3', name: '余氯仪' },
        { value: '4', name: '提升泵' },
      ],
      regionList: [ //所属区域列表
        { value: 1, name: '1#区域', },
        { value: 2, name: '2#区域', },
        { value: 3, name: '3#区域', },
      ],
      // 模拟数据
      list: [
        {
          id: '1',
          processUnit: '加药间',
          deviceType: '加药泵',
          deviceName: '1#次氯酸钠投加泵',
          deviceCode: 'JY-P-001',
          innerData: [
            {
              id: '1-1',
              alarmPropertyName: '运行状态',
              alarmName: '设备故障报警',
              alarmThreshold: '状态值=0',
              createTime: '2025-10-01 10:00:00',
              updateTime: '2025-12-20 15:30:22'
            },
            {
              id: '1-2',
              alarmPropertyName: '出口压力',
              alarmName: '低低报',
              alarmThreshold: '<1.5m',
              createTime: '2025-10-01 10:00:00',
              updateTime: '2025-10-01 10:00:00'
            }
          ]
        },
        {
          id: '2',
          processUnit: '送水泵房',
          deviceType: '流量计',
          deviceName: '出厂水总流量计',
          deviceCode: 'FM-Q-002',
          innerData: [
            {
              id: '2-1',
              alarmPropertyName: '瞬时流量',
              alarmName: '高报',
              alarmThreshold: '> 5000 m³/h',
              createTime: '2025-11-15 09:20:00',
              updateTime: '2026-01-05 11:10:05'
            },
            {
              id: '2-2',
              alarmPropertyName: '压力值',
              alarmName: '极高报',
              alarmThreshold: '> 1.2 MPa',
              createTime: '2025-11-15 09:25:00',
              updateTime: '2026-01-05 11:15:00'
            }
          ]
        }
      ]
    }
  },
  created () {

  },
  methods: {
    // 重置
    resetList () {
      this.query = {}
    },
    // 所属区域变化
    onRegionChange (value) {
      this.query.regionId = value[value.length - 1]
    },
  },
  computed: {
    rowSelection () {
      return {
        selectedRowKeys: this.selectedRows,
        onChange: this.onSelectChange
      }
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 16px 24px;
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
}

/deep/.ant-table-thead>tr>th {
  text-align: center;
}

/* 子表格全方位美化 - 薰衣草紫配色方案 */
/deep/ .ant-table-expanded-row {
  background-color: #fff !important;
}

/deep/ .ant-table-expanded-row>td {
  background-color: #fff !important;
}

/deep/ .ant-table-expanded-row .ant-table-expanded-row-fixed {
  padding: 8px 16px;
}

.alarm-card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.alarm-card-item {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  column-gap: 28px;
  padding: 10px 16px;
  background: #fff7f7;
  border: 1px solid #f4dede;
  border-radius: 2px;
}

.alarm-card-item:hover {
  background: #ffeeee;
}

.card-field {
  display: flex;
  align-items: center;
  min-width: 0;
  color: #666;
  white-space: nowrap;
}

.field-label {
  color: #b4b4b4;
  margin-right: 6px;
}

.field-value {
  color: #666;
}

.field-value--danger {
  color: #d67f7f;
  font-weight: 600;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

/deep/.ant-card {
  border-radius: 4px;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.proportion {
  font-size: 15px;
  display: block;
  margin-bottom: 20px;
}
</style>
